<template>
  <div class="BottomBar">
    <div class="appItem" appid="browser" @click="runApp('Browser')" :class="{'activeMenu':activeMenu == 'Browser'}">
      <i class="xi-overscan xi-3x"></i>
      <span>전체화면 브라우저</span>
    </div>

    <!-- <div class="appItem" appid="calculator" @click="runApp('Calculator')"  :class="{'activeMenu':activeMenu == 'Calculator'}">
      <i class="xi-calculator xi-3x"></i>
      <span>Calculator</span>
    </div> -->

<!-- 
    <div class="appItem" appid="calculator" @click="runApp('Calculator')"  :class="{'activeMenu':activeMenu == 'Calculator'}">
      <i class="xi-lightning xi-3x"></i>
      <span>계산기</span>
    </div> -->

    
    <div class="appItem" appid="shortcuts" @click="runApp('Shortcuts')"  :class="{'activeMenu':activeMenu == 'Shortcuts'}">
      <i class="xi-external-link xi-3x"></i>
      <span>바로바기</span>
    </div>


    <div class="appItem" appid="economy" @click="runApp('Economy')"  :class="{'activeMenu':activeMenu == 'Economy'}">
      <i class="xi-flash xi-3x"></i>
      <span>전비계산기</span>
    </div>

  </div>
</template>

<script>
export default {
  name: 'BottomBar',
  data() {
    return {
      activeMenu:"",
    }
  },
  methods: {
    runApp(id){
      if( this.activeMenu == id)return;
      this.activeMenu = id;
      if( this.$route.name == id)return;
      this.$router.push( { name: id } );
    }
  },
  mounted() {
    this.runApp('Browser');
  },
  
}
</script>

<style scoped>
.BottomBar{
  position:absolute; left:0; height:120px; right:0; bottom:0;
  background-color:rgba(255,255,255,0.1);
  box-sizing: border-box;
  padding-left:50px; padding-right:50px;
}

div.BottomBar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 120px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

div.BottomBar div.appItem {
  width: 100px;
  color: #999999;
  transition: all 0.25s;
  position: relative;
  overflow: hidden;
  width:140px;
  height:120px;
  padding-top:25px;
  box-sizing: border-box;
}
div.BottomBar div.right{
  width:50%;
}

div.BottomBar div.right div.appItem{
  float: right;
}

div.BottomBar div.appItem i:nth-child(1) {
  color: #999999;
  transition: all 0.25s;
}


div.BottomBar div.appItem span {
  display: inline-block;
  width: 100%;
  transform: rotate(-0.03deg);
  font-weight: bold;
  letter-spacing: -0.25px;
  color: #666666;
}

div.BottomBar div.appItem:active {
  transform: scale(0.9);
  transition: all 0.25s;
}


div.BottomBar div.appItem:active span,
div.BottomBar div.appItem:active i {
  color: #ff3333;
  transition: all 0.25s;
}

div.BottomBar div.activeMenu span,
div.BottomBar div.activeMenu i {
  color: #ff3333 !important;
}
div.BottomBar div.activeMenu::before {
  display: inline-block;
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #FF3333;
  animation-name: rippleAnimation;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
}
@keyframes rippleAnimation{
  from{
    border-radius: 100%;
    opacity: 0.5;
    transform:scale(0);
  }
  to{
    border-radius: 0;
    opacity: 0;
    transform:scale(2);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BottomBar.vue